export enum ActionButtonContent {
  ICON = 'icon',
  TEXT = 'text',
  ICON_TEXT = 'icon-text',
}
